import { TeamOutlined } from '@ant-design/icons'
import { ProviderClient } from '../../abstract/provider.client'
import { ProviderPostCommon } from '../common'

export const ProviderPostClient: ProviderClient = {
  key: ProviderPostCommon.key,
  description: {
    label: 'Post',
    icon: <TeamOutlined />,
    triggers: [],
    actions: [],
  },
}
